let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hfT7k")).then(() => parcelRequire('lvs8O'));